import { createUseStyles } from 'react-jss';

const useStyle = createUseStyles({
  cell: (props) => ({
    display: 'flex',
    flexWrap: (
      props.autoWrap ? 'wrap' : 'nowrap'
    ),
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: (
      props.fill ? 'space-between' : 'auto'
    ),
    width: '100%',
  }),
});

export default useStyle;
